"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiFetch = exports.JsonFetch = void 0;
var http_1 = require("./http");
/**
 * A simple HTTP client for handling JSON payloads.
 *
 * Really just a middleware wrapper around fetch that provides reasonable defaults for the application.
 *
 * What defaults?:
 *  - JSON inputs and outputs
 *  - Authentication
 */
function JsonFetch(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var token, params_1, queryParams, result, data, publicToken, e;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!request.headers) {
                        request.headers = {};
                    }
                    if (!request.method) {
                        request.method = 'GET';
                    }
                    request.headers['Content-Type'] = 'application/json';
                    request.headers['Accept'] = 'application/json';
                    return [4 /*yield*/, (0, http_1.getToken)()];
                case 1:
                    token = _b.sent();
                    if (token) {
                        request.headers['Authorization'] = "Bearer ".concat(token);
                    }
                    else if (request === null || request === void 0 ? void 0 : request.noAuthDefault) {
                        return [2 /*return*/, request === null || request === void 0 ? void 0 : request.noAuthDefault];
                    }
                    if (typeof request.query === 'object') {
                        params_1 = (request.query || {});
                        queryParams = Object.keys(params_1)
                            .filter(function (key) { return params_1[key] !== undefined; })
                            .map(function (key) { return "".concat(key, "=").concat(encodeURI(params_1[key])); })
                            .join('&');
                        if (request.url.includes('?')) {
                            request.url = request.url + "&".concat(queryParams);
                        }
                        else {
                            request.url = request.url + "?".concat(queryParams);
                        }
                    }
                    return [4 /*yield*/, fetch(request.url, {
                            method: request.method,
                            headers: request.headers,
                            body: JSON.stringify(request.data),
                        })];
                case 2:
                    result = _b.sent();
                    data = null;
                    if (!((_a = result.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json'))) return [3 /*break*/, 4];
                    return [4 /*yield*/, result.json()];
                case 3:
                    data = _b.sent();
                    _b.label = 4;
                case 4:
                    if (result.status >= 400) {
                        publicToken = token ? token.split('.', 2).join('.') + '.1234' : '';
                        console.error('Request failed', result.status, data);
                        console.log('Request Data', {
                            token: publicToken,
                            method: request.method,
                            url: request.url,
                            status: result.status,
                            responseBody: data,
                        });
                        e = new Error('Request failed. ' + request.url);
                        //@ts-ignore
                        e.data = data;
                        throw e;
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.JsonFetch = JsonFetch;
function ApiFetch(request) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, JsonFetch(request)];
                case 1:
                    result = _e.sent();
                    return [2 /*return*/, {
                            data: ((result === null || result === void 0 ? void 0 : result.data['_']) || (result === null || result === void 0 ? void 0 : result.data) || null),
                            paging: ((_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.meta) === null || _a === void 0 ? void 0 : _a['_']) === null || _b === void 0 ? void 0 : _b._) === null || _c === void 0 ? void 0 : _c.paging) || ((_d = result === null || result === void 0 ? void 0 : result.meta) === null || _d === void 0 ? void 0 : _d.paging),
                        }];
            }
        });
    });
}
exports.ApiFetch = ApiFetch;
